import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';

const Container = styled.div`
  top:auto !important;
  left: auto !important;
  border: 2px solid lightgrey;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${props => (props.isDragging ? 'lightgreen' : 'white')};
`;
// cursor:  ${props => (props.isDragging ? 'pointer !important;' : 'pointer !important;')} 
// cursor:move !important; cursor:-webkit-grab !important; cursor:-moz-grab !important; cursor:grab !important;
// cursor: -webkit-grab; !important; cursor: -moz-grab !important; cursor: grab !important;

const Content = (props) => {

    const deleteData = (data, index, columnId) => {
        //console.log();
        props.deleteContent(data, index, columnId)
    }

    return (
        <Draggable draggableId={`${props.value.jobShiftReleaseOrderId}`} index={props.index}>
            {(provided, snapshot) => (
                <Container
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                    isDragging={snapshot.isDragging}
                >
                    {/* <span className='handle' {...provided.dragHandleProps}></span> for moving with specific area only  */}
                    {props.value.jobShiftReleaseOrderName}
                    <spn className='pull-right'>{props.columnId !== 'column-1' && <i class="fa fa-solid fa-close fa-lg me-2" style={{ cursor: 'pointer' }} onClick={() => deleteData(props.value, props.index, props.columnId)}></i>} <i class="fa fa-solid fa-ellipsis-v fa-lg"></i></spn>
                </Container>
            )}
        </Draggable>
    )
}

export default Content;
